module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-footer"
  }, [_c('div', {
    staticClass: "footer-content"
  }, [_c('div', {
    staticClass: "up-part"
  }, [_c('div', {
    staticClass: "up-left"
  }, [_c('div', {
    staticClass: "about"
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.goUrl('/aboutUs', '')
      }
    }
  }, [_vm._v("关于八戒小贷")])]), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "row",
      "margin-top": "10px"
    }
  }, [_c('div', [_c('div', {
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.goUrl('/aboutUs', 'Introduce')
      }
    }
  }, [_vm._v("公司介绍")])]), _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "cursor": "pointer"
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.goUrl('/aboutUs', 'Cultrue')
      }
    }
  }, [_vm._v("企业文化")])])]), _c('div', {
    staticStyle: {
      "margin-left": "40px"
    }
  }, [_c('div', {
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.goUrl('/aboutUs', 'Course')
      }
    }
  }, [_vm._v("发展历程")])]), _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "cursor": "pointer"
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.showPl()
      }
    }
  }, [_vm._v("信息披露")])])])])]), _vm._m(0), _vm._m(1)]), _vm._m(2)]), _c('discloseDialog', {
    ref: "discloseDialog"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "up-middle"
  }, [_c('div', {
    staticClass: "about"
  }, [_vm._v("客服热线")]), _c('div', {
    staticClass: "phone",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("023-88392602")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "up-right"
  }, [_c('div', {
    staticClass: "about"
  }, [_vm._v("商务合作")]), _c('div', {
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_vm._v("bjjrkf@bajiegroup.com")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "down-part"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "https://beian.miit.gov.cn/state/outPortal/loginPortal.action",
      "target": "_blank"
    }
  }, [_vm._v("Copyright 2019-2020 jr-zbj.com 版权所有 | 渝ICP备2025066797号-1")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1295d3f0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1295d3f0","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@zbj/vue-mixin-loader?{"mixinPath":"D://zhubajie//Project//nodejs-zbjfins-web//app//resource//global//css//mixin//mixin.less"}!./app/resource/components/c-footer/index.vue
// module id = 1184
// module chunks = 2